module.exports = __webpack_public_path__ + "media/images/items/static-2-f38fe0e74860176d8f2dd0f7e2efc6a5.jpg";